import { Link } from "@inertiajs/react"
import { Plus } from "lucide-react"

import { Button } from "@/components/ui/button"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import type { PlayerSeason } from "@/types/serializers"

interface Props {
  seasons: PlayerSeason[]
  isOwnProfile?: boolean
}

export default function StatsTable({ seasons, isOwnProfile }: Props) {
  if (seasons.length === 0) {
    return (
      <div className="py-8 text-center">
        <p className="text-muted-foreground">
          Aún no se agregaron estadísticas
        </p>
        {isOwnProfile && (
          <Button variant="outline" size="sm" className="mt-3" asChild>
            <Link href="/perfil/temporadas">
              <Plus className="mr-1.5 h-4 w-4" />
              Agregar temporada
            </Link>
          </Button>
        )}
      </div>
    )
  }

  return (
    <div className="border-border overflow-hidden rounded-lg border">
      <Table>
        <TableHeader>
          <TableRow className="border-border bg-krown-grey-85 hover:bg-krown-grey-85">
            <TableHead className="text-krown-200 text-xs font-semibold tracking-wider uppercase">
              Temporada
            </TableHead>
            <TableHead className="text-krown-200 text-xs font-semibold tracking-wider uppercase">
              Club
            </TableHead>
            <TableHead className="text-krown-200 text-xs font-semibold tracking-wider uppercase">
              División
            </TableHead>
            <TableHead className="text-krown-200 text-center text-xs font-semibold tracking-wider uppercase">
              PJ
            </TableHead>
            <TableHead className="text-krown-200 text-center text-xs font-semibold tracking-wider uppercase">
              Goles
            </TableHead>
            <TableHead className="text-krown-200 text-center text-xs font-semibold tracking-wider uppercase">
              Asist.
            </TableHead>
            <TableHead className="text-krown-200 text-center text-xs font-semibold tracking-wider uppercase">
              TA
            </TableHead>
            <TableHead className="text-krown-200 text-center text-xs font-semibold tracking-wider uppercase">
              TR
            </TableHead>
            <TableHead className="text-krown-200 text-center text-xs font-semibold tracking-wider uppercase">
              Min.
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {seasons.map((season, index) => (
            <TableRow
              key={season.id}
              className={`border-border ${index % 2 === 0 ? "bg-card" : "bg-krown-grey-85"}`}
            >
              <TableCell className="font-medium text-white">
                {season.season_name}
              </TableCell>
              <TableCell className="text-krown-grey-30">
                {season.club_name ?? "—"}
              </TableCell>
              <TableCell className="text-krown-grey-30">
                {season.division ?? "—"}
              </TableCell>
              <TableCell className="text-center text-white">
                {season.matches_played}
              </TableCell>
              <TableCell className="text-center text-white">
                {season.goals}
              </TableCell>
              <TableCell className="text-center text-white">
                {season.assists}
              </TableCell>
              <TableCell className="text-center text-white">
                {season.yellow_cards}
              </TableCell>
              <TableCell className="text-center text-white">
                {season.red_cards}
              </TableCell>
              <TableCell className="text-center text-white">
                {season.minutes_played}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
